/**
 * Sets some sane calculator configuration defaults for Accelerate tenants when Dealer.com settings are missing.
 * This includes deal type settings, negotiation flags, taxes & fees settings, and various payment criteria.
 *
 * @param {Object} config - The calculator configuration object.
 * @param {('New'|'Used')} vehicleType - The type of vehicle (e.g., 'new', 'used').
 * @returns {Object} The updated calculator configuration object with default dealer settings applied to missing values.
 */

function applyFallbackDrSettings(config, vehicleType) {
  // make things a little more readable
  const {
    supportedDealTypes,
    initialDealType,
    selectedCriteria
  } = config;

  // apply defaults if not already set and return the updated config
  return {
    ...config,
    supportedDealTypes: supportedDealTypes ?? (vehicleType === 'New' ? ['finance', 'lease', 'cash'] : ['finance', 'cash']),
    initialDealType: initialDealType ?? 'finance',
    // input fields
    selectedCriteria: {
      ...selectedCriteria,
      selectedLoanTerm: selectedCriteria?.selectedLoanTerm ?? 72,
      selectedCreditType: selectedCriteria?.selectedCreditType ?? 'verygood',
      financeDownPayment: selectedCriteria?.financeDownPayment ?? null,
      leaseDownPayment: selectedCriteria?.leaseDownPayment ?? 2000,
      financeDownPaymentPercentage: selectedCriteria?.financeDownPaymentPercentage ?? 0.1,
      leaseDownPaymentPercentage: selectedCriteria?.leaseDownPaymentPercentage ?? 0.1,
      selectedLeaseTerm: selectedCriteria?.selectedLeaseTerm ?? 36,
      selectedLeaseMileage: selectedCriteria?.selectedLeaseMileage ?? 10000,
      leaseMileageOptions: selectedCriteria?.leaseMileageOptions ?? [10000, 12000, 15000],
      leaseTermOptions: selectedCriteria?.leaseTermOptions ?? [24, 36, 39, 48]
    }
  };
}
export { applyFallbackDrSettings as default };
